<template>
  <v-dialog :value="active" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('Contact.Form.header')}}</span>
      </v-card-title>
      <v-card-text>
        <p>{{$t('Contact.Form.intro')}}</p>
        <p v-if="phone"><strong>{{$t('Contact.Form.byPhone')}} :</strong> {{phone}}</p>
        <p v-if="mail"><strong>{{$t('Contact.Form.byMail')}} :</strong> {{mail}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">{{$t('Global.Action.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: "TheContactModal",
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    phone() {
      if (!this.user) {
        return false
      }

      return this.user.mall.phone
    },
    mail() {
      if (!this.user) {
        return false
      }

      return this.user.mall.validationEmail
    },
    ...mapState('contact', [
      'active'
    ])
  },
  methods: {
    ...mapMutations('contact', [
      'closeModal'
    ]),
    close () {
      this.closeModal()
    }
  }
}
</script>
